<template>
  <div>
    <div :key="$store.getters['resource/currentResource'].key">
      <plan-view
        :id="this.$route.params.id"
        :editing="true"
      >
      </plan-view>
    </div>
  </div>
</template>

<script>
  import PlanView from "./PlanView.vue";

  export default {
    components: {PlanView},
    middleware: 'auth',
    name: 'PlanEditing',

    created() {
      if (!this.$route.params.id) {
        this.$router.push({path: '/plans'})
      }
    }
  }
</script>